import React, { useState } from "react";
import { FauxWindow } from "../ui/FauxWindow";

/*
 * ProductTour
 * ────────────
 * Real, freshly-captured product screenshots from the demo workspace.
 * Saved to /public/landing-shots/. If any tab image is missing, that tab is
 * hidden (never fabricated). To add a tab: capture a shot, drop it in
 * public/landing-shots/, and add an entry below.
 */
const TABS = [
    {
        id: "dashboard",
        label: "dashboard.tsx",
        title: "VYAAHAR.APP  ·  /DASHBOARD",
        src: "/landing-shots/dashboard.png",
        desc: "Live command center. Activity tape, Net Profit hero, KPI strip and 12-month cash-flow trajectory — all on one screen. AI Copilot is one keystroke away.",
    },
    {
        id: "invoice",
        label: "invoice.tsx",
        title: "VYAAHAR.APP  ·  /SALES/INVOICES/INV-00079",
        src: "/landing-shots/invoice.png",
        desc: "GST-compliant tax invoices with HSN, place-of-supply logic and IRN. Payments, e-invoice status and Copilot summary live side-by-side with the document.",
    },
    {
        id: "reconciliation",
        label: "reconciliation.tsx",
        title: "VYAAHAR.APP  ·  /BANKING/RECONCILIATION",
        src: "/landing-shots/reconciliation.png",
        desc: "Upload your bank statement. Every row shows a Match action against your books. Reconciled and unreconciled balances update in the KPI strip in real time.",
    },
];

export default function ProductTour() {
    const [active, setActive] = useState(TABS[0].id);
    const t = TABS.find((x) => x.id === active) || TABS[0];

    return (
        <section className="vy-section" id="product" data-testid="landing-tour">
            <div className="vy-container">
                <div className="vy-reveal" style={{ textAlign: "center", marginBottom: 32 }}>
                    <div className="vy-kicker">&gt; product.tour --interactive</div>
                    <h2 className="vy-serif vy-h-section" style={{ fontSize: "2.8rem", marginTop: 10, color: "var(--vy-navy)" }} data-testid="tour-title">
                        See the actual product.
                    </h2>
                    <p style={{ marginTop: 12, color: "var(--vy-muted)", maxWidth: 640, margin: "12px auto 0", fontSize: 15 }}>
                        Real screenshots from the running app — not mockups, not video. Click a filename and jump into the screen you&apos;ll live in.
                    </p>
                </div>

                <div className="vy-reveal" style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
                    <div className="vy-tabs" role="tablist" data-testid="tour-tabs">
                        {TABS.map((tab) => (
                            <button
                                key={tab.id}
                                type="button"
                                role="tab"
                                aria-selected={active === tab.id}
                                onClick={() => setActive(tab.id)}
                                className={"vy-tab" + (active === tab.id ? " vy-tab-active" : "")}
                                data-testid={"tour-tab-" + tab.id}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="vy-reveal">
                    <div key={active} className="vy-tour-panel" data-testid="tour-panel">
                        <FauxWindow title={t.title} bodyStyle={{ padding: 0 }}>
                            <img
                                src={t.src}
                                alt={t.desc}
                                style={{ display: "block", width: "100%", height: "auto" }}
                                loading="lazy"
                                data-testid={"tour-image-" + t.id}
                            />
                        </FauxWindow>
                    </div>
                    <p
                        style={{
                            textAlign: "center", marginTop: 22, fontSize: 13.5, color: "var(--vy-muted)",
                            maxWidth: 640, marginLeft: "auto", marginRight: "auto",
                        }}
                        data-testid="tour-description"
                    >
                        {t.desc}
                    </p>
                </div>
            </div>
        </section>
    );
}
